import React from 'react';
import { action } from 'mobx';
import { observer, inject } from 'mobx-react';
import { Droppable, Draggable } from 'react-beautiful-dnd';
import { injectIntl } from 'react-intl';

import CardAttachmentImage from './CardAttachmentImage';
import MoveToBlockDropDown from './MoveToBlockDropDown';

const getItemStyle = (draggableStyle, isDragging) => ({
  // some basic styles to make the items look a bit nicer
  userSelect: 'none',
  //padding: grid * 2,
  //margin: `0 0 ${grid}px 0`,

  // change background colour if dragging
  background: isDragging ? '#e3e3e3' : 'transparent',

  // styles we need to apply on draggables
  ...draggableStyle
});

@inject('rootStore')
@observer
class Card extends React.Component {
  constructor(props) {
    super(props);

    this.state = {};

    this.handleEditCard = this.handleEditCard.bind(this);
    this.canEdit = props.rootStore.authorizationStore.canEdit;
  }

  render() {
    const { card, blockStore, intl, index } = this.props;

    return (
      <Draggable key={card.id} draggableId={card.id} index={index}>
        {(provided, snapshot) => (
          <div>
            <li
              ref={provided.innerRef}
              {...provided.dragHandleProps}
              {...provided.draggableProps}
              className="card"
              onClick={this.handleEditCard.bind(null, card)}
            >
              <CardBody card={card} intl={intl} canEdit={this.canEdit} />
            </li>

            {provided.placeholder}
          </div>
        )}
      </Draggable>
    );
  }

  @action
  handleEditCard(card, e) {
    const { blockStore } = this.props;

    if (this.canEdit) {
      blockStore.showEditingCardBlockModal(card);
    }
  }
}

@observer
class CardBody extends React.Component {
  constructor(props) {
    super(props);

    this.state = {};
  }

  render() {
    const { card, canEdit, intl } = this.props;
    //const label = Object.values(BMC_STAGES).includes(card.label) ? intl.formatMessage({id: card.label}) : card.label;

    return (
      <div>
        <div className="card-body">
          {card.name && (
            <div>
              <span className="badge">{card.name}</span>
              <br />
            </div>
          )}
          {/*label && ( <span>{label}<br/></span> ) */}
          {card.originalBmcName && (
            <div>
              <span style={{ fontSize: 10 }} className="bold">
                {card.originalBmcName}
              </span>
              <br />
            </div>
          )}
          {card.description} <br />
          <CardAttachmentImage attachments={card.attachments} />
          {canEdit && card.store.rootStore.isVerySmallWindows && (
            <div className="move-to-dropdown-container">
              <MoveToBlockDropDown card={card} />
            </div>
          )}
        </div>
        <div className="card-badges"></div>
      </div>
    );
  }
}

export default injectIntl(Card);
